/**
 * Debug logger that only outputs in development mode.
 * Use instead of console.log for non-critical debug messages.
 */

const isDev = import.meta.env.DEV

export function debug(tag: string, ...args: unknown[]) {
  if (isDev) {
    console.log(`[${tag}]`, ...args)
  }
}

export function debugWarn(tag: string, ...args: unknown[]) {
  if (isDev) {
    console.warn(`[${tag}]`, ...args)
  }
}

export function debugError(tag: string, ...args: unknown[]) {
  if (isDev) {
    console.error(`[${tag}]`, ...args)
  }
}
